import { render, staticRenderFns } from "./Resgates.vue?vue&type=template&id=4450ac2a"
import script from "./Resgates.vue?vue&type=script&lang=js"
export * from "./Resgates.vue?vue&type=script&lang=js"
import style0 from "./Resgates.vue?vue&type=style&index=0&id=4450ac2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports